import * as React from 'react'
import {
  Datagrid,
  List,
  Create,
  Edit,
  TextField,
  TextInput,
  NumberInput,
  ArrayInput,
  CreateButton,
  ExportButton,
  SimpleFormIterator,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  TopToolbar,
  sanitizeListRestProps,
  useListContext,
  AutocompleteArrayInput,
  Show,
  SimpleShowLayout,
  ArrayField,
  ReferenceField,
  NumberField,
  SingleFieldList,
  ReferenceArrayField,
  ChipField,
  Filter,
  usePermissions,
} from 'react-admin'
import { v4 as uuid } from 'uuid'

import { TabbedForm } from '../components/TabbedForm'
import { ArchivedSelect, FullNameField } from '../components/selects'
import { useCourseIds } from '../utils/useCourseIds'
// import { runSeed } from '../utils/seed'

const ListBase = (props) => {
  const course_ids = useCourseIds()

  return (
    <List
      filter={course_ids ? { id: course_ids } : null}
      filters={<CourseFilter />}
      sort={{ field: 'name', order: 'ASC' }}
      perPage={25}
      actions={<Actions />}
      {...props}
    >
      <CourseList {...props} />
    </List>
  )
}

const ShowBase = (props) => (
  <Show {...props}>
    <CourseShow />
  </Show>
)

const CreateBase = (props) => (
  <Create {...props}>
    <CourseForm />
  </Create>
)

const EditBase = (props) => (
  <Edit undoable={false} {...props}>
    <CourseForm />
  </Edit>
)

export const list = ListBase
export const edit = EditBase
export const show = ShowBase
export const create = CreateBase

const CourseFilter = (props) => (
  <Filter style={{ margin: 10 }} {...props}>
    <ArchivedSelect />
  </Filter>
)

const CourseList = (props) => (
  <Datagrid
    rowClick={props.permissions?.includes('admin') ? 'edit' : 'show'}
    {...props}
  >
    <TextField label="Course Name" source="name" />
  </Datagrid>
)

const CourseShow = (props) => (
  <SimpleShowLayout {...props}>
    <TextField fullWidth source="name" />

    <ArrayField source="assessments">
      <Datagrid>
        <ReferenceField
          label="Assessment"
          source="assessment_id"
          reference="assessments"
        >
          <TextField source="name" />
        </ReferenceField>
        <NumberField label="Scheduled Day" source="day_index" />
      </Datagrid>
    </ArrayField>

    <ReferenceArrayField
      label="Instructors"
      source="instructor_ids"
      reference="users"
    >
      <SingleFieldList>
        <FullNameField style={{ marginRight: 8 }} />
      </SingleFieldList>
    </ReferenceArrayField>

    <ReferenceArrayField
      label="Assignments"
      source="assignment_ids"
      reference="assignments"
    >
      <SingleFieldList>
        <ChipField source="name" />
      </SingleFieldList>
    </ReferenceArrayField>
  </SimpleShowLayout>
)

const CourseForm = (props) => (
  <TabbedForm
    {...props}
    labels={['Basic', 'Staff', 'Assignments']}
    pages={[BasicForm, StaffForm, AssignmentForm]}
  />
)

const BasicForm = (props) => {
  const id = props.values?.id || `COURSE#${uuid()}`
  return (
    <>
      <TextInput fullWidth label="Course Name" source="name" />
      <TextInput style={{ display: 'none' }} defaultValue={id} source="sk" />

      <ArrayInput source="assessments">
        <SimpleFormIterator>
          <ReferenceInput
            allowEmpty={false}
            perPage={100}
            label="Assessment"
            source="assessment_id"
            reference="assessments"
            style={{ float: 'left', width: '45%', marginRight: 16 }}
          >
            <SelectInput optionText="name" />
          </ReferenceInput>
          <NumberInput
            label="Scheduled Day"
            source="day_index"
            style={{ float: 'left', width: '45%' }}
          />
        </SimpleFormIterator>
      </ArrayInput>
    </>
  )
}

const StaffForm = (props) => {
  return (
    <>
      <ReferenceArrayInput
        fullWidth
        allowEmpty={false}
        label="Instructors"
        source="instructor_ids"
        sort={{ field: 'email', order: 'ASC' }}
        filterToQuery={(searchText) => ({ q: { email: searchText } })}
        reference="users"
        perPage={100}
      >
        <AutocompleteArrayInput optionText="email" translateChoice={false} />
      </ReferenceArrayInput>
    </>
  )
}

const AssignmentForm = (props) => {
  return (
    <>
      <ReferenceArrayInput
        fullWidth
        allowEmpty={false}
        sort={{ field: 'name', order: 'ASC' }}
        label="Assignments"
        source="assignment_ids"
        reference="assignments"
        perPage={100}
      >
        <AutocompleteArrayInput optionText="name" translateChoice={false} />
      </ReferenceArrayInput>
    </>
  )
}
const Actions = (props) => {
  const { className, exporter, filters, maxResults, ...rest } = props
  const {
    currentSort,
    resource,
    displayedFilters,
    filterValues,
    basePath,
    showFilter,
    total,
  } = useListContext()
  const { permissions } = usePermissions()

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      {permissions?.includes('admin') && (
        <>
          <CreateButton basePath={basePath} />
          <ExportButton
            disabled={total === 0}
            resource={resource}
            sort={currentSort}
            filterValues={filterValues}
            maxResults={maxResults}
          />
        </>
      )}
      {/* {false && (
        <Button
          onClick={() => {
            const confirmed = window.confirm(
              "WARNING: This will re-seed the database.  Only confirm if you know what you're doing",
            )
            if (confirmed) runSeed()
          }}
          label="Seed"
        ></Button>
      )} */}
    </TopToolbar>
  )
}
